module.exports = __webpack_public_path__ + "assets/img/btn-more-3a55cad0.png";